import { Component, MouseEvent, MouseEventHandler } from 'react'
import * as styles from 'styles/atoms/CategoriesOverlay.css'
import { OverlayMobile } from 'components/features/pfm/Overlay/OverlayMobile'
import { PopupTitle } from 'components/atoms/Text'

export type InlineDropdownCheckSelected<TEntity> = (e: MouseEvent<HTMLElement>) => TEntity | null

export type CategoriesOvelrayProps<TEntity> = {
  getCaption: (entity: TEntity) => string
  selected: TEntity
  checkSelected: InlineDropdownCheckSelected<TEntity>
  onSelect: (selectedOption: TEntity) => void
}

type CategoriesOvelrayState = {
  isOpened: boolean
}

class CategoriesOvelray<TEntity extends { id: any }> extends Component<CategoriesOvelrayProps<TEntity>, CategoriesOvelrayState> {
  state = {
    isOpened: false,
  }

  render () {
    const { isOpened } = this.state
    const {
      selected,
      getCaption,
      children,
    } = this.props

    return (
      <>
        <a
          className={ styles.caption }
          onClick={ this.handleCaptionClick }
        >
          { getCaption(selected) }
        </a>
        { isOpened && (
          <OverlayMobile onClose={ this.close }>
            <div className={ styles.titleWrapper }>
              <PopupTitle>
                Select a Category
              </PopupTitle>
            </div>
            <div onClick={ this.handleContentClick }>
              { children }
            </div>
          </OverlayMobile>
        )}
      </>
    )
  }

  private close = () => {
    this.setState({ isOpened: false })
  }

  private handleCaptionClick = () => {
    this.setState({
      isOpened: true,
    })
  }

  private handleContentClick: MouseEventHandler<HTMLDivElement> = (e) => {
    const { checkSelected, onSelect } = this.props
    const selected = checkSelected(e)
    if (selected && selected.id !== this.props.selected.id) {
      onSelect(selected)
    }
    this.close()
  }
}

export default CategoriesOvelray
